import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { auth } from "../utils/auth";

import MobileHeader from "./general/MobileHeader";
import Sidebar from "./general/Sidebar";
import DesktopHeader from "./general/DesktopHeader";

import Login from "./Login";
import NewDashboard from "./HomeDashboard/new";
import Empleados from "./Empleados";
import Nominas from "./Nominas";
import ViewNomina from "./Nominas/View";
import CrearEmpleado from "./Empleados/Create";
import LayoutEmpleado from "./Empleados/Layout";
import Vehiculos from "./Vehiculos";
import Reclamaciones from "./Reclamaciones";
import CrearVehiculo from "./Vehiculos/Create";
import LayoutVehiculo from "./Vehiculos/Layout";
import Programaciones from "./Programaciones";
import Edit from "./Programaciones/Edit";
import Rutas from "./Rutas";
import Reportes from "./Reportes/Form";
import Usuarios from "./Configuracion/Usuarios";
import Tipos from "./Configuracion/Tipos";
import Categorias from "./Configuracion/Categorias";
import Asignaciones from "./Configuracion/Asignaciones";
import Solicitudes from "./Solicitudes";
import Sucursales from "./Configuracion/Sucursales";
import Configuracion from "./Configuracion";
import Almacenes from "./Configuracion/Almacenes";
import Grupos from "./Configuracion/Grupos";
import Items from "./Items";
import LayoutItem from "./Items/Layout";
import Servicios from "./Servicios";
import Gastos from "./Gastos";
import CrearGastos from "./Gastos/CreateMultiple";
import GastosGenerales from "./GastosGenerales";
import CrearGastosGenerales from "./GastosGenerales/Create";
import Contactos from "./Contactos";
import Compras from "./Compras";
import EditCompras from "./Compras/Edit";
import CrearCompras from "./Compras/Create";
import Modal from "./general/Modal";
import DescuentosProgramados from "./DescuentosProgramados";

class Dashboard extends Component {
    state = {
        isLoggedIn: auth.isLoggedIn(),
        showReportes: false,
    };
    componentDidMount() {
        window.addEventListener("storage", this.syncLogout);

        auth.inactivityTime();
    }
    componentWillUnmount() {
        window.removeEventListener("storage", this.syncLogout);
        window.localStorage.removeItem("logout");
    }
    syncLogout = (event) => {
        if (event.key === "logout") {
            this.setState({ isLoggedIn: auth.isLoggedIn() });
        }
    };
    toggleModal = (modal, show = null) => {
        this.setState({
            [modal]: show === null ? !this.state[modal] : show,
        });
    };
    render() {
        if (!this.state.isLoggedIn) return <Login />;

        let MainView = NewDashboard;

        if (auth.is("digitador")) {
            MainView = Programaciones;
        } else if (auth.is("gasto")) {
            MainView = Gastos;
        }

        const sucursal = auth.getUser().sucursalActual;

        return (
            <div>
                <MobileHeader />
                <Sidebar toggleModal={this.toggleModal} />
                <div className='page-container'>
                    <DesktopHeader toggleModal={this.toggleModal} />
                    <div className='main-content'>
                        <div className='section__content section__content--p30'>
                            <div className='container-fluid'>
                                <Switch>
                                    <Route
                                        path="/"
                                        exact
                                        render={({ location }) => (
                                            <Redirect
                                                to={{
                                                    pathname: `/${sucursal}`,
                                                    state: { from: location },
                                                }}
                                            />
                                        )}
                                    />
                                    <Route
                                        path='/:sucursal/'
                                        exact
                                        component={MainView}
                                    />
                                    <ProtectedRoute
                                        exact
                                        can={auth.can("ver-configuracion")}
                                        path='/:sucursal/sucursales'>
                                        <Sucursales />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        can={auth.can("ver-empleados")}
                                        path='/:sucursal/empleados'>
                                        <Empleados />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        can={auth.can("ver-empleados")}
                                        path='/:sucursal/empleados/crear'>
                                        <CrearEmpleado />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        can={auth.can("ver-empleados")}
                                        path='/:sucursal/empleados/:id/*'>
                                        <LayoutEmpleado />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/nomina'
                                        can={auth.can("ver-nomina")}>
                                        <Nominas />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/nomina/:id'
                                        can={auth.can("ver-nomina")}>
                                        <ViewNomina />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/solicitudes'
                                        can={auth.can("ver-solicitudes")}>
                                        <Solicitudes />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/reclamaciones'
                                        can={auth.can("ver-reclamaciones")}>
                                        <Reclamaciones />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/descuentos'
                                        can={auth.can("ver-descuentos")}>
                                        <DescuentosProgramados />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/servicios'
                                        can={auth.can("ver-servicios")}>
                                        <Servicios />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/vehiculos/crear'
                                        can={auth.can("ver-vehiculos")}>
                                        <CrearVehiculo />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/vehiculos/:id/*'
                                        can={auth.can("ver-vehiculos")}>
                                        <LayoutVehiculo />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/vehiculos'
                                        can={auth.can("ver-vehiculos")}>
                                        <Vehiculos />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/rutas'
                                        can={auth.can("ver-rutas")}>
                                        <Rutas />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/reportes'
                                        can={auth.can("ver-reportes")}>
                                        <Reportes />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/programaciones'
                                        can={auth.can("ver-programacion")}>
                                        <Programaciones />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/programaciones/:id'
                                        can={auth.can("ver-programacion")}>
                                        <Edit />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/inventario'
                                        can={auth.can("ver-inventario")}>
                                        <Items />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/inventario/:id/*'
                                        can={auth.can("ver-inventario")}>
                                        <LayoutItem />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/gastos'
                                        exact
                                        can={auth.can("ver-gastos")}>
                                        <Gastos />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/gastos/crear'
                                        can={auth.can("ver-gastos")}>
                                        <CrearGastos />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/gastos-generales'
                                        exact
                                        can={auth.can("ver-gastos-generales")}>
                                        <GastosGenerales />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/gastos-generales/crear'
                                        can={auth.can("ver-gastos-generales")}>
                                        <CrearGastosGenerales />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/compras'
                                        can={auth.can("ver-compras")}>
                                        <Compras />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/compras/crear'
                                        can={auth.can("ver-compras")}>
                                        <CrearCompras />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/compras/:id'
                                        can={auth.can("ver-compras")}>
                                        <EditCompras />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/usuarios'
                                        can={auth.can("ver-configuracion")}>
                                        <Usuarios />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/contactos'
                                        can={auth.can("ver-contactos")}>
                                        <Contactos />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        exact
                                        path='/:sucursal/configuracion'
                                        can={auth.can("ver-configuracion")}>
                                        <Configuracion />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/usuarios'
                                        can={auth.can("ver-configuracion")}>
                                        <Usuarios />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/tipos'
                                        can={auth.can("ver-configuracion")}>
                                        <Tipos />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/categorias'
                                        can={auth.can("ver-configuracion")}>
                                        <Categorias />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/asignaciones'
                                        can={auth.can("ver-configuracion")}>
                                        <Asignaciones />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/almacenes'
                                        can={auth.can("ver-configuracion")}>
                                        <Almacenes />
                                    </ProtectedRoute>
                                    <ProtectedRoute
                                        path='/:sucursal/configuracion/grupos'
                                        can={auth.can("ver-configuracion")}>
                                        <Grupos />
                                    </ProtectedRoute>
                                </Switch>

                                <Modal
                                    show={this.state.showReportes}
                                    blank={true}
                                    toggle={() =>
                                        this.toggleModal("showReportes")
                                    }>
                                    <Reportes
                                        toggle={() =>
                                            this.toggleModal("showReportes")
                                        }
                                    />
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function ProtectedRoute({ children, can, ...rest }) {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                can ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
}

export default Dashboard;
